import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet><loader></loader>'
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/app.component.ts